import { type ReactNode } from 'react';
import { useIntl } from 'react-intl';
import * as Styled from './LoginPage.styled';

interface LoginPanelProps {
  readonly panelId: string;
  readonly description: string;
  readonly children: ReactNode;
}

export const ExternalLoginPanel = ({ panelId, description, children }: LoginPanelProps) => {
  const intl = useIntl();

  return (
    <Styled.SignInPanel id={panelId}>
      <Styled.PanelTitle>
        {intl.formatMessage({ id: 'pleaseSignIn', defaultMessage: 'Please sign in' })}
      </Styled.PanelTitle>
      <Styled.PanelDescription>{description}</Styled.PanelDescription>
      <Styled.PanelButtonRow>{children}</Styled.PanelButtonRow>
    </Styled.SignInPanel>
  );
};
